import React from 'react'
import Constants from 'src/helper/Constants'
import System from 'src/helper/system'
import QuoteConfig from "@system/config/quote";

const QuoteCheckoutSummary = () => {
  const { storageName: { QUOTE_CART_LIST } } = System

  const quoteList = JSON.parse(sessionStorage.getItem(QUOTE_CART_LIST))
  const sub_total = quoteList?.reduce((acc, cur) => {
    const total = Number(cur.subtotal)
    acc += total
    return acc
  }, 0)


  return (
    <div className="cart-shopping-detail">
      <div className="cart-shipping-detail">
        <div className="bs5 row">
          <div className="col-12">
            <div className="bs5 row m-0 mini-cart-item-total">
              <div className="col-7 px-0">
                <span>
                  <span className="cart-item-count">
                    ({quoteList?.length}){" "}
                  </span>
                  Items Subtotal:
                </span>
              </div>
              <div className="col-5 text-end font_bold_currency ps-1">
                <span className="font_bold_currency">
                  {System.getFormatNumber({ amount: sub_total || 0, maximumFractionDigits: 2 })}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="bs5 row">
          <div className="col-7">
            <span>Estimated Shipping: </span>
          </div>
          <div className="col-5 text-end font_bold_currency">
            <span>--</span>
          </div>
        </div>
        <div className="bs5 row font_bold_currency">
          <div className="col-7">
            <span>Estimated Tax: </span>
          </div>
          <div className="col-5 text-end ">
            <span>--</span>
          </div>
        </div>
      </div>

      <div className="bs5 row m-0">
        <div className="order-total" >
          <div className="bs5 row font_bold_currency">
            <div className="col-5">
              <span>Order Total: </span>
            </div>
            <div className="col-7 text-end">
              <div>
                <span className='subtotal-currency'>
                  {Constants.currencyType.USD}
                </span>
                <span className="ms-1">
                  {System.getFormatNumber({ amount: sub_total || 0, maximumFractionDigits: 2 })}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="shopping-option text-center">
        <a href={void 0} onClick={() => window.location.href = QuoteConfig.getQuoteCheckoutRouteURL()} className={`bs5 btn btn-primary d-block most-viewd-item-btn m-auto`} >
          <span className="fa add-cart-lock-icon me-1" /> Checkout
        </a>
        <span className="instruction text-black-stone d-block mt-2">
          Taxes, shipping and tariff charges to be calculated at checkout. Pricing does not include applicable federal, state, or local sales, use, or other taxes or import duties imposed on Avnet or its suppliers.(If Hawaii excise taxes are applicable, rates are as follows .05% for Wholesale transactions and 4% for Retail transactions.)
        </span>
      </div>
    </div>
  )
}

export default QuoteCheckoutSummary